import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  number: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '32px',
    width: 'calc(100% - 0.5rem)',
    color: theme.palette.textLightFaded
  },

  cost: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    paddingRight: '1rem',
    fontFamily: 'monospace'
  },

  pdf: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '0.5rem',
    width: '100%',
    minHeight: '52px',

    '& img': {
      height: '32px',
      width: '32px'
    }
  }
}))

export default useStyles
